<div class="h-full bg-background">
    <app-header></app-header>
    <app-side-bar></app-side-bar>
    <main class="h-screen box-border pt-[70px] pb-[49px] overflow-y-auto">
        <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
</div>
